export const FETCH_FLEET_POLLING = 5000;

export const Other = {
    downloadDoc (_this) {
        return _this.$requester
        .get(`/userGuide`, { params: { page: _this.$route.meta.langLabel }, responseType: 'blob' })
        .then(response => {
            //const dtrum = window.dtrum; 
            //dtrum.enterAction('Userguide Event')
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            var  pureFileName = response.headers["content-disposition"]
            var  filename = pureFileName.substring(pureFileName.indexOf('=') + 1);

            filename = filename.replace('"',"")
            filename = filename.replace('"',"")
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
        })
        .catch(error => {
            console.log(error)
        })
    }
}
